/* Layout only. The `margin-top` left with the title: this panel is a
   `PageSection` now, so the space before it belongs to the host that mounts the
   readings (`RecordBody.module.css`) and the space between two of them belongs
   to `.section + .section`. A panel deciding its own distance from whatever
   happens to precede it is what #2283 is converting away from.

   `panelTitle` is DELETED, not unused: `sectionHierarchy.test.ts` asserts the
   private title system a conversion replaced can never be declared again. */
.wrap { display: flex; flex-direction: column; }
/* The registry ROWS are the kit's `ServerCheck` now (#2406 cards-inputs):
   `.rowline`, `.key`, `.value`, `.act` and `.detail` are DELETED — the kit row
   draws the name, the status, the registry's words, the act at the row's end
   and the joint between two rows, and says the answer aloud when it lands. */
.note { margin: 0; color: var(--muted); }
